const mapLayers = {
	temperature: "Temperature",
	salinity: "Salinity",
	currents: "Currents"
};

export default mapLayers;
export { mapLayers };
